import { Box, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import React from 'react';

export interface INoItemBox {
  height: number;
  text: string;
  minHeight?: number;
}

const NoItemBox = (props: INoItemBox) => {
  return (
    <Box height={props.height} justifyContent="center" display="contents">
      <div
        style={{
          display: 'flex',
          border: `2px dashed ${grey[300]}`,
          margin: '32px 32px 47px 32px',
          textAlign: 'center',
          alignItems: 'center',
          height: `${props.height - 79}px`,
          minHeight: props.minHeight ? `${props.minHeight - 79}px` : '200px',
          padding: '30px',
        }}
      >
        <Typography
          variant="body2"
          style={{
            fontWeight: 400,
            fontSize: '1rem',
            fontStyle: 'italic',
            marginTop: '15px',
            width: '100%',
            textAlign: 'center',
          }}
        >
          {props.text}
        </Typography>
      </div>
    </Box>
  );
};

export default NoItemBox;
